import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnDetailedCheckboxTemplateOptions } from './detailed-checkbox-template-options.interface';

export interface ISnDetailedCheckboxFormFieldConfig extends FormlyFieldConfig {
  type: 'detailed-checkbox';
  templateOptions: ISnDetailedCheckboxTemplateOptions;
}
